export function formatRelative(isoDate) {
  if (!isoDate) return "—";
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return "—";
  const diff = (Date.now() - d.getTime()) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return "just now";
  if (abs < 3600) return `${Math.round(abs / 60)}m ago`;
  if (abs < 86400) return `${Math.round(abs / 3600)}h ago`;
  if (abs < 86400 * 30) return `${Math.round(abs / 86400)}d ago`;
  if (abs < 86400 * 365) return `${Math.round(abs / (86400 * 30))}mo ago`;
  return `${Math.round(abs / (86400 * 365))}y ago`;
}

export function fmtNumber(n) {
  if (n === null || n === undefined || n === "") return "—";
  return Number(n).toLocaleString();
}

export function fmtRating(r) {
  if (r === null || r === undefined || r === "") return "—";
  return Number(r).toFixed(1);
}
